import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, CtaButton } from "@/components/Bits";
import { ZUBEHOER } from "@/data/catalog";

const CAT_IMG =
  "https://images.unsplash.com/photo-1610165539750-051008c3e799?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Zubehoer() {
  return (
    <>
      <Seo
        title="Zubehör"
        description="Optik, Führungssysteme, Schalldämpfer, Holster und Waffenpflege — abgestimmtes Zubehör für Ihr System bei IMPEXMILTRADE GMBH in Mureck."
      />
      <PageHeader
        code="SEK-03 / Optik · Führung · Pflege"
        title="Zubehör"
        sub="Das richtige Zubehör macht die Waffe komplett. Von Zielfernrohren und Rotpunktvisieren über Schalldämpfer bis zu Holstern, Pflege und zertifizierten Waffenschränken — abgestimmt auf Ihren Einsatz."
      />

      <section className="relative border-b border-border">
        <div className="relative h-64 overflow-hidden md:h-80">
          <img src={CAT_IMG} alt="Optik und Zubehör" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-background/40" aria-hidden />
          <div className="blueprint-grid absolute inset-0 opacity-30" aria-hidden />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16" data-testid="zubehoer-list">
        <div className="mb-8 flex items-center justify-between border-b border-border pb-4">
          <p className="mono-label text-primary">Kategorien</p>
          <p className="mono-label text-muted-foreground">{ZUBEHOER.length} Bereiche</p>
        </div>

        <div className="grid border-l border-t border-border sm:grid-cols-2 lg:grid-cols-4">
          {ZUBEHOER.map((z, i) => (
            <motion.div
              key={z.code}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
              className="border-b border-r border-border p-6 transition-colors hover:bg-card"
              data-testid={`zubehoer-${z.code}`}
            >
              <span className="mono-label text-primary">{z.code}</span>
              <h3 className="mt-4 font-display text-xl font-600 uppercase tracking-tight">{z.name}</h3>
              <p className="mt-2 font-body text-sm text-muted-foreground">{z.detail}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 border border-border p-8 text-center">
          <p className="font-body text-muted-foreground">
            Optik-Montage, Einschießen oder individuelle Konfiguration — wir richten Ihr System ein.
          </p>
          <div className="mt-6 flex justify-center">
            <CtaButton to="/kontakt" testid="zubehoer-cta">
              Beratung anfragen <ArrowRight size={16} />
            </CtaButton>
          </div>
        </div>
      </section>
    </>
  );
}
